// account urls
import useDataApps from '../hooks/data/useDataApps'
import { APP_TYPES } from '../utils/permissions'

export const account = () => '/account'
export const login = () => '/login'
export const register = () => '/register'
export const apps = () => '/apps'
export const analyticsBlueForceRedForce = () => '/analytics/blue-force-red-force'
export const analyticsUnitReadiness = () => '/analytics/unit-readiness'
export const analyticsMap = () => '/analytics/map'
export const homeBase = () => '/'

export const useTorqFlowUrl = () => {
  const apps = useDataApps()
  return apps.find(app => app.appType === APP_TYPES.TORQ_FLOW)?.url
}

export const useTorqDataUrl = () => {
  const apps = useDataApps()
  return apps.find(app => app.appType === APP_TYPES.TORQ_DATA)?.url
}

export const useTorqNLPUrl = () => {
  const apps = useDataApps()
  return apps.find(app => app.appType === APP_TYPES.TORQ_NLP)?.url
}

export const useTorqAgentsUrl = () => {
  const apps = useDataApps()
  return apps.find(app => app.appType === APP_TYPES.TORQ_AGENT)?.url
}

// torqsecure urls
export const aolytics = () => 'https://aolytix.aws.intellibridgelabs.io'
export const sbomSecurity = () => '/torq-secure/sbom-security'
